import { PhonePipe } from './phone/phone.pipe';

// /* eslint-disable  @typescript-eslint/no-explicit-any */
export const pipes: any[] = [PhonePipe];

export * from './phone/phone.pipe';
